import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

interface NavigationState {
  isCollapsed: boolean;
  toggleCollapse: () => void;
  setCollapsed: (collapsed: boolean) => void;
}

export const useNavigationStore = create<NavigationState>()(
  devtools(
    persist(
      (set) => ({
        isCollapsed: false,
        toggleCollapse: () =>
          set(
            (state) => ({ isCollapsed: !state.isCollapsed }),
            undefined,
            'navigation/toggleCollapse',
          ),
        setCollapsed: (collapsed: boolean) =>
          set({ isCollapsed: collapsed }, undefined, 'navigation/setCollapsed'),
      }),
      {
        name: 'navigation-store', // localStorage key
        partialize: (state) => ({ isCollapsed: state.isCollapsed }), // only persist isCollapsed
      },
    ),
    {
      name: 'navigation-store',
    },
  ),
);
